module.exports = __webpack_public_path__ + "img/enem-60-dias.cb21c37c.png";